var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataApiDefaultSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "11.7516mm",
    height: "12mm",
    viewBox: "0 0 33.31162 34.01575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a {\n        fill: #181f28;\n      }\n\n      .b {\n        fill: #4b9fd8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.92785,17.72369a2.375,2.375,0,0,0-1.92611.9898H1.394A1.39384,1.39384,0,0,0,.40839,21.093L10.56693,31.25157a2.44545,2.44545,0,1,0,1.97618-1.96615l-7.78374-7.784h24.2423a2.38122,2.38122,0,1,0,1.92618-3.77772Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.87574,12.2755,22.75153,2.69611a2.35814,2.35814,0,0,0,.0315-.31234,2.40572,2.40572,0,1,0-1.94623,2.3396l7.57936,7.171H4.31a2.38378,2.38378,0,1,0,0,2.78792H31.9174a1.39415,1.39415,0,0,0,.95834-2.40676Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataApiDefaultSmall);
export default __webpack_public_path__ + "static/media/data-api_default_small.83c54621aa5f216d2a08c1f0eefe31d2.svg";
export { ForwardRef as ReactComponent };